module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$root.dataReady) ? _c('div', {
    staticClass: "work"
  }, [(_vm.showModal) ? _c('modal', {
    on: {
      "close": function($event) {
        _vm.showModal = false
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "videoWrapper"
  }, [_c('iframe', {
    attrs: {
      "src": _vm.videosrc,
      "frameborder": "0",
      "allow": "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
      "allowfullscreen": ""
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('header', {
    staticClass: "heading"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.page.content.rendered)
    }
  }), _vm._v(" "), (_vm.videosrc) ? _c('a', {
    staticClass: "btn default white white-play",
    attrs: {
      "id": "show-modal"
    },
    on: {
      "click": function($event) {
        _vm.showModal = true
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "13px",
      "height": "14px",
      "viewBox": "0 0 13 14",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "latest-deck",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    staticClass: "btn-svg",
    attrs: {
      "id": "3-offer",
      "transform": "translate(-827.000000, -1427.000000)",
      "fill": "#FFFFFF"
    }
  }, [_c('polygon', {
    attrs: {
      "id": "Path-2",
      "points": "827 1427 827 1441.03125 839.1875 1434.03125"
    }
  })])])]), _vm._v("\n          " + _vm._s(_vm.button_text) + "\n        ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "bg-work",
    class: _vm.page.acf.hero_picture_position,
    style: ({
      'background-image': 'url( ' + _vm.page.better_featured_image.source_url + ' )',
    })
  }, [_c('div', {
    staticClass: "hero-caption"
  }, [_c('em', [_vm._v(_vm._s(_vm.hero_caption))])])]), _vm._v(" "), _c('div', {
    staticClass: "mouse-icon-container"
  }, [_c('a', {
    staticClass: "scroll-down-section",
    on: {
      "click": function($event) {
        return _vm.scrollToNextSection()
      }
    }
  }, [_vm._m(0)])])]), _vm._v(" "), _c('div', {
    staticClass: "posts"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.posts), function(post, index) {
    return [(index % 4 == 1 && index % 2 != 0) ? _c('div', {
      key: index,
      staticClass: "col-l-4 col-m-4 col-s-12"
    }, [_c('router-link', {
      staticClass: "post",
      attrs: {
        "tag": "a",
        "to": '/' + _vm.slug + '/' + post.slug
      }
    }, [_c('p', {
      staticClass: "title",
      domProps: {
        "innerHTML": _vm._s(post.title.rendered)
      }
    }), _vm._v(" "), (post.better_featured_image) ? _c('div', {
      staticClass: "bg",
      style: ({
        'background-image': 'url( ' + post.better_featured_image.source_url + ' )',
      })
    }) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (index % 4 == 2 && index % 2 == 0) ? _c('div', {
      key: index,
      staticClass: "col-l-4 col-m-4 col-s-12"
    }, [_c('router-link', {
      staticClass: "post",
      attrs: {
        "tag": "a",
        "to": '/' + _vm.slug + '/' + post.slug
      }
    }, [_c('p', {
      staticClass: "title",
      domProps: {
        "innerHTML": _vm._s(post.title.rendered)
      }
    }), _vm._v(" "), (post.better_featured_image) ? _c('div', {
      staticClass: "bg",
      style: ({
        'background-image': 'url( ' + post.better_featured_image.source_url + ' )',
      })
    }) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (index % 4 == 3 && index % 2 != 0) ? _c('div', {
      key: index,
      staticClass: "col-l-8 col-m-8 col-s-12"
    }, [_c('router-link', {
      staticClass: "post",
      attrs: {
        "tag": "a",
        "to": '/' + _vm.slug + '/' + post.slug
      }
    }, [_c('p', {
      staticClass: "title",
      domProps: {
        "innerHTML": _vm._s(post.title.rendered)
      }
    }), _vm._v(" "), (post.better_featured_image) ? _c('div', {
      staticClass: "bg",
      style: ({
        'background-image': 'url( ' + post.better_featured_image.source_url + ' )',
      })
    }) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (index % 4 == 0 && index % 2 == 0) ? _c('div', {
      key: index,
      staticClass: "col-l-8 col-m-8 col-s-12"
    }, [_c('router-link', {
      staticClass: "post",
      attrs: {
        "tag": "a",
        "to": '/' + _vm.slug + '/' + post.slug
      }
    }, [_c('p', {
      staticClass: "title",
      domProps: {
        "innerHTML": _vm._s(post.title.rendered)
      }
    }), _vm._v(" "), (post.better_featured_image) ? _c('div', {
      staticClass: "bg",
      style: ({
        'background-image': 'url( ' + post.better_featured_image.source_url + ' )',
      })
    }) : _vm._e()])], 1) : _vm._e()]
  })], 2)])], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mouse-icon"
  }, [_c('span', {
    staticClass: "mouse-wheel"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bf43f63a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Work.vue
// module id = 365
// module chunks = 0